import React from 'react'

import Box from 'components/Box'
import DateWithToolTip from 'components/DateWithToolTip'
import { Notification } from 'types/global'

type Props = Pick<Notification, 'createTs'>

const NotificationFooter: React.FC<Props> = ({ createTs }) => (
  <Box display="flex" paddingTop="15px" paddingBottom="15px">
    <DateWithToolTip date={createTs} color="gray5" showHumanized />
  </Box>
)

export default NotificationFooter
